import React, { useState, useCallback, useEffect } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { Button, Input } from "src/components";
import {
  useAccountPhoneConfirmCode,
  useAccountUpdateIdentification,
} from "src/hooks";
import LocalText from "src/local";
import alert from "src/components/alert";

export type PhoneProps = {
  documents: Array<string>;
  onDone: () => void;
};

export const Phone: React.FC<PhoneProps> = (props) => {
  const [phone, setPhone] = useState<string>("");
  const [code, setCode] = useState<string>("");
  const [codeSent, setCodeSent] = useState<boolean>(false);
  const [hideCodeSend, setHideCodeSend] = useState<boolean>(false);
  const [
    accountPhoneConfirmCodeHandler,
    accountPhoneConfirmCodeLoading,
    accountPhoneConfirmCodeError,
  ] = useAccountPhoneConfirmCode();
  const [
    accountUpdateIdentificationHandler,
    accountUpdateIdentificationLoading,
    accountUpdateIdentificationError,
  ] = useAccountUpdateIdentification();
  let _isMount = false;
  // const [account] = useAccount();

  useEffect(() => {
    _isMount = true;
    return () => {
      _isMount = false;
    };
  }, []);

  useEffect(() => {
    if (accountPhoneConfirmCodeError) {
      alert(accountPhoneConfirmCodeError.message, undefined, [
        {
          text: LocalText.common.ok,
          style: "cancel",
        },
      ]);
    }
  }, [accountPhoneConfirmCodeError]);

  useEffect(() => {
    if (accountUpdateIdentificationError) {
      alert(accountUpdateIdentificationError.message, undefined, [
        {
          text: LocalText.common.ok,
          style: "cancel",
        },
      ]);
    }
  }, [accountUpdateIdentificationError]);

  const sendCodeHandler = useCallback(async () => {
    if (await accountPhoneConfirmCodeHandler({ phone })) {
      setCodeSent(true);
      setHideCodeSend(true);
      setTimeout(() => {
        if (_isMount) {
          setHideCodeSend(false);
        }
      }, 60 * 1000);
      alert(LocalText.screens.identification.phone.codeSentAlertTitle);
    }
  }, [phone]);

  const doneHandler = useCallback(async () => {
    if (
      await accountUpdateIdentificationHandler({
        phone,
        code,
        documents: props.documents,
      })
    ) {
      props.onDone();
    }
  }, [phone, code, props]);

  return (
    <View style={styles.container}>
      <ScrollView style={{ backgroundColor: "white" }}>
        <Input
          label={LocalText.screens.identification.phone.phone}
          autoCapitalize={"none"}
          placeholder={LocalText.screens.identification.phone.phonePlaceholder}
          value={phone}
          onChangeText={(text: string) => setPhone(text)}
          keyboardType={"numeric"}
        />

        {codeSent && (
          <Input
            label={LocalText.screens.identification.phone.code}
            autoCapitalize={"none"}
            placeholder={LocalText.screens.identification.phone.codePlaceholder}
            value={code}
            onChangeText={(text: string) => setCode(text)}
            keyboardType={"numeric"}
          />
        )}
      </ScrollView>
      <View style={styles.actionContainer}>
        {!hideCodeSend && (
          <Button
            containerStyle={styles.chatActionContainer}
            variant={"secondary"}
            disabled={phone.length !== 11}
            loading={accountPhoneConfirmCodeLoading}
            title={
              codeSent
                ? LocalText.screens.identification.phone.codeResend
                : LocalText.screens.identification.phone.codeSend
            }
            onPress={sendCodeHandler}
          />
        )}
        {codeSent && (
          <Button
            containerStyle={styles.offerActionContainer}
            disabled={code.length === 0}
            loading={accountUpdateIdentificationLoading}
            variant={"primary"}
            title={LocalText.common.done}
            onPress={() => doneHandler()}
          />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  actionContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    padding: 16,
    shadowColor: colors.black,
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.1,
    backgroundColor: colors.white,
  },
  chatActionContainer: {
    flex: 1,
    marginRight: 8,
  },
  offerActionContainer: {
    flex: 1,
    marginLeft: 8,
  },
  container: {
    flex: 1,
  },
});
